import { actions } from '@/store/modules/deviceUi/actions'
import { getters } from '@/store/modules/deviceUi/getters'
import { mutations } from '@/store/modules/deviceUi/mutations'
import { state } from '@/store/modules/deviceUi/state'
import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { DeviceUiAction, DeviceUiGetter, DeviceUiMutation, DeviceUiState } from './types'

const namespaced: boolean = true
export const deviceUi: Module<DeviceUiState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
}

export const types = {
  action: DeviceUiAction, 
  mutation: DeviceUiMutation,
  getter: DeviceUiGetter,
}

export const domain = 'deviceUi'

export const vuexModule = {
  [domain]: deviceUi,
}